import { useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { CouponGiftListDTO, CouponsApiListCouponGiftsRequest } from 'probonio-shared-ui/api';
import { apis, useTenantQuery } from 'probonio-shared-ui/module/api';
import { useTenantID } from 'probonio-shared-ui/module/me';
import { useCallback } from 'react';

export const useRefetchBudgetOrders = (): (() => Promise<void>) => {
  const queryClient = useQueryClient();
  const getTenantId = useTenantID();

  return useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey: ['tenants', getTenantId(), 'benefits', 'coupons', 'budgetOrders'] });
  }, [queryClient, getTenantId]);
};

export function useCouponGifts(
  employeeId: string,
  params: Omit<CouponsApiListCouponGiftsRequest, 'tenantId' | 'employeeId'>,
): UseQueryResult<CouponGiftListDTO> {
  return useTenantQuery(
    ['employees', employeeId, 'benefits', 'coupons', 'gifts', JSON.stringify(params), apis.coupons.listCouponGifts.name],
    tenantId => apis.coupons.listCouponGifts({ tenantId, employeeId, ...params }).then(res => res.data),
    {
      placeholderData: previousData => previousData,
    },
  );
}
